import { defineRecipe, SystemStyleObject } from "@chakra-ui/react";

export type CustomLinkVariants = "plain" | "underline";

const variants: Record<CustomLinkVariants, SystemStyleObject> = {
  plain: {
    color: "currentColor",
    textDecoration: "none",
    textDecorationColor: "currentColor",
    _hover: {
      textDecorationColor: "currentColor",
      textDecoration: "underline",
    },
  },
  underline: {
    color: "currentColor",
    textDecoration: "underline",
    textDecorationColor: "currentColor",
    _hover: {
      textDecoration: "none",
    },
  },
};

export const LinkStyles = defineRecipe({
  base: {
    _focus: {
      outline: "none",
    },
  },
  variants: {
    variant: variants,
  },
  defaultVariants: {
    variant: "underline",
  },
});
